import Clarity from '@microsoft/clarity';
import type { AccountInfo } from '@azure/msal-browser';

declare global {
  interface Window {
    clarity?: typeof Clarity;
  }
}

const environment = import.meta.env.VITE_DEPLOY_ENV;
const isProduction = environment === 'production';

/**
 * Identify a user to Clarity
 * @param account The user account to identify
 */
export function identifyUserToClarity(account: AccountInfo) {
  if (!isProduction) {
    return;
  }

  if (typeof window.clarity === 'undefined') {
    console.warn('Clarity is not initialized. Skipping user identification.');
    return;
  }

  const email = account.idTokenClaims?.email as string;
  Clarity.identify(email, undefined, undefined, email);
}

/**
 * Initialize MS Clarity based on environment
 */
export function initializeClarity() {
  const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID;

  if (isProduction) {
    Clarity.init(projectId);
  }
}
